import React, { useContext } from "react";
import toast from "react-hot-toast";
import { Link } from "react-router-dom";
import { AuthContext } from "../../../App";
import Logo from "./../../../assets/logo/navbar-logo.png";
const Navbar = () => {
  const { user, logOut } = useContext(AuthContext);
  const logOutHandler = () => {
    logOut()
      .then((res) => {
        toast.success("Log Out Successful!");
      })
      .catch((error) => toast.error("Log Out Fail!"));
  };
  return (
    <div className="navbar top-0 sticky z-10 bg-[#020E4A] h-20">
      <div className="navbar-start">
        <div className="dropdown">
          <label tabIndex={0} className="btn btn-ghost lg:hidden">
            {/* <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h8m-8 6h16"
              />
            </svg> */}
            <svg
      viewBox="0 0 512 512"
      fill="currentColor"
      height="2em"
      width="2em"
      className="text-white"
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeMiterlimit={10}
        strokeWidth={48}
        d="M88 152h336M88 256h336M88 360h336"
      />
    </svg>
          </label>
          <ul
            tabIndex={0}
            className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 w-64 font-medium"
          >
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/services">Services</Link>
            </li>
            <li>
              <Link to="/blog">Blog</Link>
            </li>
            <li>
              <Link to="/review">All Review</Link>
            </li>
            {user?.uid ? (
              <li>
                <Link to="/my-review">My Review</Link>
              </li>
            ) : (
              <></>
            )}
          </ul>
        </div>
        <Link to="/" className="flex gap-1 items-center">
          <img src={Logo} className="h-14" alt="" />
          <h2 className="font-bold text-2xl md:text-3xl text-white">EduGenius</h2>
        </Link>
      </div>
      <div className="navbar-center hidden lg:flex">
        <ul className="menu menu-horizontal p-0 text-white font-medium">
          <li>
            <Link to="/">Home</Link>
          </li>
          <li>
            <Link to="/services">Services</Link>
          </li>
          <li>
            <Link to="/blog">Blog</Link>
          </li>
          <li>
            <Link to="/review">All Review</Link>
          </li>
          {user?.uid ? (
            <li>
              <Link to="/my-review">My Review</Link>
            </li>
          ) : (
            <></>
          )}
        </ul>
      </div>
      <div className="navbar-end gap-2">
      
      

        {user?.uid ? (
          <button onClick={logOutHandler}>
            <Link to="/" className="">
            <button class="bg-red-600 hover:bg-red-700 text-white font-bold py-2 px-4 rounded shadow-lg">Logout</button>
            </Link>
          </button>
        ) : (
          <>
            <Link to="/register" className="">
            <button class="bg-gradient-to-r from-purple-600 to-pink-600 hover:from-pink-600 hover:to-purple-600 text-white font-bold py-3 px-6 rounded-md shadow-lg">Sign Up</button>
            </Link>
            <Link to="/login" className="">
            <button class="bg-gradient-to-r from-green-400 to-blue-500 hover:from-blue-500 hover:to-green-400 text-white font-bold py-3 px-6 rounded-md shadow-lg">Login</button>
            </Link>
            
          </>
        )}
      </div>
    </div>
  );
};

export default Navbar;
